import React from 'react';
import { FileText, Edit2, Send, Eye, Trash2, Clock, CalendarClock } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { DOC_TYPE_LABELS, formatExpiry } from './documentConstants';

export const TemplateCard = ({ template, onPreview, onEdit, onPublish, onDelete }) => (
  <Card className="border border-gray-200" data-testid={`template-card-${template.id}`}>
    <CardHeader className="pb-3">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-lg bg-amber-50">
            <FileText className="h-5 w-5 text-amber-600" />
          </div>
          <div>
            <CardTitle className="text-base">{template.title}</CardTitle>
            <div className="flex items-center gap-2 mt-1 flex-wrap">
              <Badge variant="outline" className="text-xs">
                {DOC_TYPE_LABELS[template.doc_type] || template.doc_type.replace(/_/g, ' ')}
              </Badge>
              <span className="text-xs text-gray-400">v{template.version}</span>
              {template.expires_in_days ? (
                <Badge className="bg-blue-50 text-blue-600 text-xs border-blue-200">
                  <CalendarClock className="h-3 w-3 mr-1" />
                  Expires: {formatExpiry(template.expires_in_days)}
                </Badge>
              ) : (
                <Badge className="bg-gray-50 text-gray-500 text-xs border-gray-200">
                  <Clock className="h-3 w-3 mr-1" />
                  No expiration
                </Badge>
              )}
            </div>
          </div>
        </div>
      </div>
    </CardHeader>
    <CardContent className="pt-0">
      <p className="text-xs text-gray-400 mb-4">
        Last updated: {new Date(template.updated_at).toLocaleDateString('en-US', {
          month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit',
        })}
      </p>
      <div className="flex items-center gap-2 flex-wrap">
        <Button variant="outline" size="sm" onClick={() => onPreview(template)} data-testid={`preview-template-${template.id}`}>
          <Eye className="h-3.5 w-3.5 mr-1.5" /> Preview
        </Button>
        <Button variant="outline" size="sm" onClick={() => onEdit(template)} data-testid={`edit-template-${template.id}`}>
          <Edit2 className="h-3.5 w-3.5 mr-1.5" /> Edit
        </Button>
        <Button size="sm" className="bg-amber-500 hover:bg-amber-600 text-white" onClick={() => onPublish(template)} data-testid={`publish-template-${template.id}`}>
          <Send className="h-3.5 w-3.5 mr-1.5" /> Publish
        </Button>
        <Button variant="ghost" size="sm" className="text-gray-400 hover:text-red-500" onClick={() => onDelete(template)} data-testid={`delete-template-${template.id}`}>
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </div>
    </CardContent>
  </Card>
);
